// NIST SP 800-171 Control Weights for SPRS Score Calculation
// Source: DoD CMMC Assessment Guide and NIST SP 800-171A
// Weights: -1 (standard), -3 (high impact), -5 (critical)

export const CONTROL_WEIGHTS = {
  // ACCESS CONTROL (AC) — 22 controls
  'AC.L2-3.1.1':  -1,
  'AC.L2-3.1.2':  -1,
  'AC.L2-3.1.3':  -1,
  'AC.L2-3.1.4':  -1,
  'AC.L2-3.1.5':  -3,
  'AC.L2-3.1.6':  -1,
  'AC.L2-3.1.7':  -3,
  'AC.L2-3.1.8':  -1,
  'AC.L2-3.1.9':  -1,
  'AC.L2-3.1.10': -1,
  'AC.L2-3.1.11': -1,
  'AC.L2-3.1.12': -1,
  'AC.L2-3.1.13': -3,
  'AC.L2-3.1.14': -1,
  'AC.L2-3.1.15': -1,
  'AC.L2-3.1.16': -1,
  'AC.L2-3.1.17': -1,
  'AC.L2-3.1.18': -1,
  'AC.L2-3.1.19': -1,
  'AC.L2-3.1.20': -1,
  'AC.L2-3.1.21': -1,
  'AC.L2-3.1.22': -1,

  // AWARENESS AND TRAINING (AT) — 3 controls
  'AT.L2-3.2.1':  -1,
  'AT.L2-3.2.2':  -1,
  'AT.L2-3.2.3':  -1,

  // AUDIT AND ACCOUNTABILITY (AU) — 9 controls
  'AU.L2-3.3.1':  -3,
  'AU.L2-3.3.2':  -1,
  'AU.L2-3.3.3':  -1,
  'AU.L2-3.3.4':  -1,
  'AU.L2-3.3.5':  -1,
  'AU.L2-3.3.6':  -1,
  'AU.L2-3.3.7':  -1,
  'AU.L2-3.3.8':  -1,
  'AU.L2-3.3.9':  -1,

  // CONFIGURATION MANAGEMENT (CM) — 9 controls
  'CM.L2-3.4.1':  -3,
  'CM.L2-3.4.2':  -3,
  'CM.L2-3.4.3':  -1,
  'CM.L2-3.4.4':  -1,
  'CM.L2-3.4.5':  -1,
  'CM.L2-3.4.6':  -1,
  'CM.L2-3.4.7':  -1,
  'CM.L2-3.4.8':  -1,
  'CM.L2-3.4.9':  -1,

  // IDENTIFICATION AND AUTHENTICATION (IA) — 11 controls
  'IA.L2-3.5.1':  -1,
  'IA.L2-3.5.2':  -1,
  'IA.L2-3.5.3':  -5,
  'IA.L2-3.5.4':  -1,
  'IA.L2-3.5.5':  -1,
  'IA.L2-3.5.6':  -1,
  'IA.L2-3.5.7':  -1,
  'IA.L2-3.5.8':  -1,
  'IA.L2-3.5.9':  -1,
  'IA.L2-3.5.10': -1,
  'IA.L2-3.5.11': -3,

  // INCIDENT RESPONSE (IR) — 3 controls
  'IR.L2-3.6.1':  -3,
  'IR.L2-3.6.2':  -3,
  'IR.L2-3.6.3':  -1,

  // MAINTENANCE (MA) — 6 controls
  'MA.L2-3.7.1':  -1,
  'MA.L2-3.7.2':  -1,
  'MA.L2-3.7.3':  -1,
  'MA.L2-3.7.4':  -1,
  'MA.L2-3.7.5':  -1,
  'MA.L2-3.7.6':  -1,

  // MEDIA PROTECTION (MP) — 9 controls
  'MP.L2-3.8.1':  -1,
  'MP.L2-3.8.2':  -1,
  'MP.L2-3.8.3':  -1,
  'MP.L2-3.8.4':  -1,
  'MP.L2-3.8.5':  -1,
  'MP.L2-3.8.6':  -1,
  'MP.L2-3.8.7':  -1,
  'MP.L2-3.8.8':  -1,
  'MP.L2-3.8.9':  -3,

  // PERSONNEL SECURITY (PS) — 2 controls
  'PS.L2-3.9.1':  -1,
  'PS.L2-3.9.2':  -1,

  // PHYSICAL PROTECTION (PE) — 6 controls
  'PE.L2-3.10.1': -1,
  'PE.L2-3.10.2': -1,
  'PE.L2-3.10.3': -1,
  'PE.L2-3.10.4': -1,
  'PE.L2-3.10.5': -1,
  'PE.L2-3.10.6': -1,

  // RISK ASSESSMENT (RA) — 3 controls
  'RA.L2-3.11.1': -3,
  'RA.L2-3.11.2': -3,
  'RA.L2-3.11.3': -1,

  // SECURITY ASSESSMENT (CA) — 4 controls
  'CA.L2-3.12.1': -3,
  'CA.L2-3.12.2': -1,
  'CA.L2-3.12.3': -1,
  'CA.L2-3.12.4': -1,

  // SYSTEM AND COMMUNICATIONS PROTECTION (SC) — 16 controls
  'SC.L2-3.13.1':  -3,
  'SC.L2-3.13.2':  -1,
  'SC.L2-3.13.3':  -1,
  'SC.L2-3.13.4':  -1,
  'SC.L2-3.13.5':  -3,
  'SC.L2-3.13.6':  -1,
  'SC.L2-3.13.7':  -1,
  'SC.L2-3.13.8':  -3,
  'SC.L2-3.13.9':  -1,
  'SC.L2-3.13.10': -3,
  'SC.L2-3.13.11': -5,
  'SC.L2-3.13.12': -1,
  'SC.L2-3.13.13': -1,
  'SC.L2-3.13.14': -1,
  'SC.L2-3.13.15': -1,
  'SC.L2-3.13.16': -1,

  // SYSTEM AND INFORMATION INTEGRITY (SI) — 7 controls
  'SI.L2-3.14.1': -3,
  'SI.L2-3.14.2': -3,
  'SI.L2-3.14.3': -1,
  'SI.L2-3.14.4': -1,
  'SI.L2-3.14.5': -1,
  'SI.L2-3.14.6': -3,
  'SI.L2-3.14.7': -1,
};

// Calculate SPRS score from assessment answers
// answers = { 'AC.L2-3.1.1': 'yes'|'partial'|'no', ... }
export function calculateSPRSScore(answers) {
  let score = 110;

  Object.entries(CONTROL_WEIGHTS).forEach(([controlId, weight]) => {
    const answer = answers[controlId];
    if (answer === 'no' || answer === 'partial' || !answer) {
      score += weight;
    }
  });

  return Math.max(-203, score);
}

export function getSPRSStatus(score) {
  if (score >= 110) return { label: 'Perfect Score', color: 'var(--green)',  bg: 'var(--green-bg)' };
  if (score >= 88)  return { label: 'Audit Ready',   color: 'var(--accent)', bg: 'var(--blue-bg)'  };
  if (score >= 0)   return { label: 'Needs Work',    color: 'var(--amber)',  bg: 'var(--amber-bg)' };
  return             { label: 'Critical Gaps',  color: 'var(--red)',    bg: 'var(--red-bg)'   };
}

export function getSPRSColor(score) {
  if (score >= 110) return '#22c55e';
  if (score >= 88)  return '#3b82f6';
  if (score >= 0)   return '#f59e0b';
  return '#ef4444';
}

// SOC 2 scoring — percentage based (0–100)
export function calculateSOC2Score(answers) {
  // SOC 2 has 64 controls; count points across all answered
  let points = 0;
  let total = 0;
  Object.entries(answers).forEach(([, val]) => {
    if (val === 'yes')     { points += 1; total += 1; }
    else if (val === 'partial') { points += 0.5; total += 1; }
    else if (val === 'no')      { total += 1; }
  });
  if (total === 0) return 0;
  return Math.round((points / total) * 100);
}

export function getSOC2Status(score) {
  if (score >= 90) return { label: 'Exceeds',  color: 'var(--green)', bg: 'var(--green-bg)' };
  if (score >= 75) return { label: 'Meets',    color: 'var(--green)', bg: 'var(--green-bg)' };
  if (score >= 50) return { label: 'Partial',  color: 'var(--amber)', bg: 'var(--amber-bg)' };
  return             { label: 'Below',    color: 'var(--red)',   bg: 'var(--red-bg)'   };
}

// ISO 27001:2022 scoring — percentage based (0–100)
export function calculateISO27001Score(answers) {
  let points = 0;
  let total  = 0;
  Object.entries(answers).forEach(([, val]) => {
    if (val === 'yes')          { points += 1;   total += 1; }
    else if (val === 'partial') { points += 0.5; total += 1; }
    else if (val === 'no')      {                total += 1; }
  });
  if (total === 0) return 0;
  return Math.round((points / total) * 100);
}

export function getISO27001Status(score) {
  if (score >= 90) return { label: 'Conformant',           color: 'var(--green)', bg: 'var(--green-bg)' };
  if (score >= 75) return { label: 'Largely Conformant',   color: 'var(--green)', bg: 'var(--green-bg)' };
  if (score >= 50) return { label: 'Partially Conformant', color: 'var(--amber)', bg: 'var(--amber-bg)' };
  return             { label: 'Non-Conformant',        color: 'var(--red)',   bg: 'var(--red-bg)'   };
}

// HIPAA Security Rule scoring — percentage based (0–100)
export function calculateHIPAAScore(answers) {
  let points = 0;
  let total  = 0;
  Object.entries(answers).forEach(([, val]) => {
    if (val === 'yes')          { points += 1;   total += 1; }
    else if (val === 'partial') { points += 0.5; total += 1; }
    else if (val === 'no')      {                total += 1; }
  });
  if (total === 0) return 0;
  return Math.round((points / total) * 100);
}

export function getHIPAAStatus(score) {
  if (score >= 90) return { label: 'Compliant',              color: 'var(--green)', bg: 'var(--green-bg)' };
  if (score >= 75) return { label: 'Substantially Compliant',color: 'var(--green)', bg: 'var(--green-bg)' };
  if (score >= 50) return { label: 'Partially Compliant',    color: 'var(--amber)', bg: 'var(--amber-bg)' };
  return             { label: 'Non-Compliant',           color: 'var(--red)',   bg: 'var(--red-bg)'   };
}

// NIST CSF 2.0 scoring — percentage based (0–100)
export function calculateNISTCSFScore(answers) {
  let points = 0;
  let total  = 0;
  Object.entries(answers).forEach(([, val]) => {
    if (val === 'yes')          { points += 1;   total += 1; }
    else if (val === 'partial') { points += 0.5; total += 1; }
    else if (val === 'no')      {                total += 1; }
  });
  if (total === 0) return 0;
  return Math.round((points / total) * 100);
}

export function getNISTCSFStatus(score) {
  if (score >= 90) return { label: 'Optimized', color: 'var(--green)', bg: 'var(--green-bg)' };
  if (score >= 75) return { label: 'Managed',   color: 'var(--green)', bg: 'var(--green-bg)' };
  if (score >= 50) return { label: 'Defined',   color: 'var(--amber)', bg: 'var(--amber-bg)' };
  return             { label: 'Partial',    color: 'var(--red)',   bg: 'var(--red-bg)'   };
}

// PCI DSS v4.0 scoring — percentage based (0–100)
export function calculatePCIDSSScore(answers) {
  let points = 0;
  let total  = 0;
  Object.entries(answers).forEach(([, val]) => {
    if (val === 'yes')          { points += 1;   total += 1; }
    else if (val === 'partial') { points += 0.5; total += 1; }
    else if (val === 'no')      {                total += 1; }
  });
  if (total === 0) return 0;
  return Math.round((points / total) * 100);
}

export function getPCIDSSStatus(score) {
  if (score >= 90) return { label: 'Compliant',          color: 'var(--green)', bg: 'var(--green-bg)' };
  if (score >= 75) return { label: 'Mostly Compliant',   color: 'var(--green)', bg: 'var(--green-bg)' };
  if (score >= 50) return { label: 'Partially Compliant',color: 'var(--amber)', bg: 'var(--amber-bg)' };
  return             { label: 'Non-Compliant',       color: 'var(--red)',   bg: 'var(--red-bg)'   };
}

// FedRAMP Moderate scoring — percentage based (0–100)
export function calculateFedRAMPScore(answers) {
  let points = 0;
  let total  = 0;
  Object.entries(answers).forEach(([, val]) => {
    if (val === 'yes')          { points += 1;   total += 1; }
    else if (val === 'partial') { points += 0.5; total += 1; }
    else if (val === 'no')      {                total += 1; }
  });
  if (total === 0) return 0;
  return Math.round((points / total) * 100);
}

export function getFedRAMPStatus(score) {
  if (score >= 90) return { label: 'Authorized',              color: 'var(--green)', bg: 'var(--green-bg)' };
  if (score >= 75) return { label: 'Conditionally Authorized', color: 'var(--green)', bg: 'var(--green-bg)' };
  if (score >= 50) return { label: 'In Progress',              color: 'var(--amber)', bg: 'var(--amber-bg)' };
  return             { label: 'Not Ready',                color: 'var(--red)',   bg: 'var(--red-bg)'   };
}